import {SummaryModel} from "../../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../../common/entity/permissions.model";
import {LovValueSummary} from "../../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {Moment} from "moment";
import {PaymentRequestSummaryModel} from "../../../api/entity/paymentRequestSummary.model";

export class PaymentRequestOnlineAttemptSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    paymentRequest: PaymentRequestSummaryModel;
    date: Moment;
    status: LovValueSummary;
    description: string;
    amount: number;
}

export enum PaymentRequestOnlineAttemptStatus {
    PAYMENT_ONLINE_STATUS_CREATED = 'PAYMENT_ONLINE_STATUS_CREATED',
    PAYMENT_ONLINE_STATUS_FAILED = 'PAYMENT_ONLINE_STATUS_FAILED',
    PAYMENT_ONLINE_STATUS_CANCELLED = 'PAYMENT_ONLINE_STATUS_CANCELLED',
    PAYMENT_ONLINE_STATUS_SUCCESSFUL = 'PAYMENT_ONLINE_STATUS_SUCCESSFUL'
}
